<template>
  <div class="synergy-ai-container">
    <div class="title">
      <FormButton class="float-right" @click="$emit('close')"><i class="fas fa-times" /></FormButton>
      <ContentTitle>Synergy AI</ContentTitle>
    </div>
    <div class="history-container">
      Blah Blah
    </div>
    <div class="entry-container">
      <FormInputText />
    </div>
  </div>
</template>

<style scoped lang="scss">
.synergy-ai-container {
  position: fixed;
  right: 0px;
  top: 0px;
  bottom: 0px;
  width: 40vw;
  min-width: 500px;
  background-color: #EBE8E4;
  border: 1px solid #a39d95;
  z-index: 100000;
  border-radius: $layout-minor-border-radius;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  padding: 10px;
}
.synergy-ai-container .history-container {
  border: 1px solid #a39d95;
  background-color: #FFFFFF;
  border-radius: $layout-small-border-radius;
  padding: 4px;
  flex: 1;
  width: 100%;
  overflow-y: scroll;
}
.synergy-ai-container .entry-container {
  padding-top: 8px;
}

</style>

<script>
export default {
  name: 'SynergyAISidebar',
  components: {
    
  },
  methods: {
    
  }
}
</script>